import { render, staticRenderFns } from "./FormsSubmit.vue?vue&type=template&id=4d2804ef&"
import script from "./FormsSubmit.vue?vue&type=script&lang=js&"
export * from "./FormsSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports